// Leads page (MIS-812 / Task 31).
//
// A read-only dashboard page listing the active tenant's leads. The data fetch,
// filters, and table live in `LeadsTable` (which uses the typed RPC client +
// React Query and reports load errors via a toast). This route file is the thin
// page shell rendered inside the `_authenticated` layout.

import { createFileRoute } from '@tanstack/react-router';
import { LeadsTable } from '@/components/leads/LeadsTable';

export const Route = createFileRoute('/_authenticated/leads/')({
  component: LeadsPage,
});

function LeadsPage() {
  return (
    <div className="space-y-6 p-8">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Leads</h1>
        <p className="text-sm text-gray-500">
          Submitted form leads for this workspace. Phone and email are masked unless you have admin
          access.
        </p>
      </div>
      <LeadsTable />
    </div>
  );
}
